import React from 'react';
import classnames from 'classnames';
import { default as Icon } from '../../../images/icon/22-2_checkcircle.svg';
import SVG from 'react-inlinesvg';

type IconProps = {
  className?: string;
};
const CheckCircle: React.FC<IconProps> = props => <SVG src={Icon} className={classnames(props.className, 'icon')} />;
export default CheckCircle;
